"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMerge = void 0;

var array_union_1 = __importDefault(require("array-union"));

var deepmerge_1 = __importDefault(require("deepmerge"));
/**
 *
 *
 * @export
 * @param {object} obj1
 * @param {object} obj2
 * @returns {object}
 */


function deepMerge() {
  var arrayMerge = function arrayMerge(destination, source) {
    return array_union_1.default(destination, source);
  };

  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return deepmerge_1.default.all(objects, {
    arrayMerge: arrayMerge
  });
}

exports.deepMerge = deepMerge;